import type {
  PurchaseRecoveryRecord,
  PurchaseRecoveryStorage,
  PurchaseSnapshot,
} from './types';

const STORAGE_KEY = 'analytics_pending_purchases';

const EMPTY_RECORD: PurchaseRecoveryRecord = { pending: [], sent: [] };

const isSnapshot = (value: unknown): value is PurchaseSnapshot =>
  typeof value === 'object' &&
  value !== null &&
  typeof (value as PurchaseSnapshot).orderId === 'string' &&
  typeof (value as PurchaseSnapshot).createdAt === 'number';

export class LocalPurchaseRecoveryStorage implements PurchaseRecoveryStorage {
  read(): PurchaseRecoveryRecord {
    if (typeof localStorage === 'undefined') {
      return { ...EMPTY_RECORD };
    }

    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return { ...EMPTY_RECORD };
      }

      const parsed = JSON.parse(raw) as Partial<PurchaseRecoveryRecord>;

      return {
        pending: Array.isArray(parsed.pending)
          ? parsed.pending.filter(isSnapshot)
          : [],
        sent: Array.isArray(parsed.sent)
          ? parsed.sent.filter((id): id is string => typeof id === 'string')
          : [],
      };
    } catch {
      return { ...EMPTY_RECORD };
    }
  }

  write(record: PurchaseRecoveryRecord): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch {
      return;
    }
  }
}
